module.exports = __webpack_public_path__ + "static/campioni-da-bar_v02-b019b7b7e209a4ae66da69bc4c674a72.png";